import { styled } from '@mui/material/styles';
import { colors } from '@sweep-io/sweep-design';
import { ReactNode, useRef, memo } from 'react';
import { Stack, Box } from '@mui/material';
import { MarkdownWrapper } from '../../MarkdownWrapper';
import { useRunOnce } from '../../useRunOnce';

const MESSAGE_STYLE = {
  pr: 1.5,
  pl: 1.5,
};

const AiChatAssistantMessageBoxSimpleComponent = ({
  content,
  onMount,
  errorState = false,
  color,
}: {
  content: string | ReactNode;
  onMount?: () => void;
  errorState?: boolean;
  color?: string;
}) => {
  const messageRef = useRef<HTMLDivElement>(null);

  useRunOnce(() => {
    onMount?.();
  });

  const markdownWrapperProps = {
    content,
    color: color ?? (errorState ? colors.blush[600] : undefined),
    removeMargins: true,
  };

  return (
    <Stack gap={0} data-message-type="assistant" data-testid="ai-chat-assistant-message-box-simple">
      <Box display="flex" gap={0.5} alignItems="flex-start">
        <AssistantMessageBox className="message-content-box" ref={messageRef} sx={MESSAGE_STYLE}>
          <MarkdownWrapper {...markdownWrapperProps} />
        </AssistantMessageBox>
      </Box>
    </Stack>
  );
};

const AssistantMessageBox = styled(Box)({
  maxWidth: '100%',
});

export const AiChatAssistantMessageBoxSimple = memo(AiChatAssistantMessageBoxSimpleComponent);
